import React from 'react';
import DataList from '../DataList';
import ApiConfigFactory from '../../configurations/ApiConfigFactory';

const VitalsLogs = ({ admissionId, disableEdit }) => {
  const dlConfig = new ApiConfigFactory(
    'admissions/vitals-logs', // serverRoute
    'Vitals Logs', // title
    'admission_id', // parentIDName
    admissionId // parentIDValue
  );

  dlConfig.title = `Vitals Logs for Admission: ${admissionId}`;
  dlConfig.allowAdd = !disableEdit; // Allow adding logs only if not disabled
  dlConfig.allowEdit = !disableEdit; // Allow editing only if not disabled
  dlConfig.path = '/admission-card/vitals-logs';
  dlConfig.defaultSortFieldId = 'log_id';
  dlConfig.conditionalStyles = {
    "Risk Level": {
        "type": "text",
        "conditions": {
          "matches": {
              "Medium": {"color": "black","backgroundColor":"yellow"},
              "High": {"color": "white","backgroundColor":"red"}
          },
            "default": {"color":"black","backgroundColor":"white"}
        }
      }
  }

  dlConfig
    .addField({ name: 'log_id', label: 'Log ID', type: 'number', identifier: true, disabled: true })
    .addField({ name: 'admission_id', label: 'Admission ID', type: 'number', defaultValue: admissionId, visible: false })
    .addField({ name: 'log_date', label: 'Date & Time', type: 'datetime-local', required: true, defaultValue: new Date().toISOString().slice(0, 16) })
    .addField({ name: 'temperature', label: 'Temperature', type: 'number', step: '0.1', required: true })
    .addField({ name: 'blood_pressure_systolic', label: 'Blood Pressure (Systolic)', type: 'number', required: true })
    .addField({ name: 'blood_pressure_diastolic', label: 'Blood Pressure (Diastolic)', type: 'number', required: true })
    .addField({ name: 'pulse', label: 'Pulse', type: 'number',required: true })
    .addField({ name: 'weight', label: 'Weight', type: 'number', step: '0.1' })
    .addField({ name: 'spo2', label: 'SpO2 (%)', type: 'number', step: '0.1', required: true })
    .addField({ name: 'respiration_rate', label: 'Respiration Rate',type: 'number', defaultValue: null})
    .addField({ name: 'on_oxygen', label: 'On Oxygen?', type: 'checkbox', defaultValue: false });

  dlConfig
    .addColumn({ id: 'log_date', name: 'Date & Time', selector: (row) => row.log_date, type: 'datetime', sortable: true })
    .addColumn({ name: 'Risk Level', selector: (row) => row.vitals_score_risk, type: 'text', sortable: true })
    .addColumn({ name: 'Temperature', selector: (row) => `${row.temperature}°C`, type: 'text' })
    .addColumn({ 
      name: 'Blood Pressure', 
      selector: (row) => `${row.blood_pressure_systolic}/${row.blood_pressure_diastolic}`, 
      type: 'text' 
    })
    .addColumn({ name: 'Pulse', selector: (row) => `${row.pulse} bpm`, type: 'text' })
    .addColumn({ name: 'Weight', selector: (row) => `${row.weight} kg`, type: 'text' })
    .addColumn({ name: 'SpO2', selector: (row) => `${row.spo2}%`, type: 'text' });

  return <DataList apiConfig={dlConfig} columns={dlConfig.columns} />;
};

export default VitalsLogs;
